module.exports = __webpack_public_path__ + "static/img/weitu-4.e69492e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weitu-4.png
// module id = thHT
// module chunks = 0